/**
 * @fileoverview Shared Project schema used by both frontend and backend.
 */

import { z } from 'zod';
import { commonValidators, createCrudSchemas, createDisplayableEntitySchema, getSchemaFields } from './base.js';
import { ID_PATTERNS, PriorityEnum } from './types.js';

export const ProjectSchema = createDisplayableEntitySchema(
  ID_PATTERNS.PROJECT,
  'ID must be in pr-prefixed nanoid7 format',
  {
    archivable: true,
    accountTracking: 'archivable',
    additionalFields: {
      priority: PriorityEnum.default('Medium'),
      start_date: commonValidators.dateString(),
      target_end_date: commonValidators.dateString(),
    },
  }
);

const { CreateSchema, UpdateSchema } = createCrudSchemas(ProjectSchema);

export const ProjectCreateSchema = CreateSchema;
export const ProjectUpdateSchema = UpdateSchema;

export type Project = z.infer<typeof ProjectSchema>;
export type ProjectCreate = z.infer<typeof ProjectCreateSchema>;
export type ProjectUpdate = z.infer<typeof ProjectUpdateSchema>;

export const PROJECT_FIELDS = getSchemaFields(ProjectSchema);
